import axios from "../api/axios";
import useAuth from "./useAuth";

const useLogout = () => {
  const { setAuth } = useAuth();

  const logout = async () => {
    // Reset local storage
    setAuth(null);
  };

  return logout;
};

export default useLogout;
